import AtletaExistente from "pages/LandingPages/AtletaExistente/atletaExiste";

export default function AtletaExistentePage() {
  return <AtletaExistente />;
}
